export * from './queries';

export const wishlistKeys = {
  wishlists: (accountId: string) => ['wishlists', accountId],
};
